export default "/public/app-main/static/image/c9b5a1916d61a59ed0f95aaa79687c60.gif";